/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMail } from './SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMail';
import {
    SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMailFromJSON,
    SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMailFromJSONTyped,
    SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMailToJSON,
} from './SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMail';

/**
 * 
 * @export
 * @interface SendCheckoutFullfillmentShippingMailRequest
 */
export interface SendCheckoutFullfillmentShippingMailRequest {
    /**
     * 
     * @type {SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMail}
     * @memberof SendCheckoutFullfillmentShippingMailRequest
     */
    fullfillmentShippingMail: SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMail;
}

/**
 * Check if a given object implements the SendCheckoutFullfillmentShippingMailRequest interface.
 */
export function instanceOfSendCheckoutFullfillmentShippingMailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fullfillmentShippingMail" in value;

    return isInstance;
}

export function SendCheckoutFullfillmentShippingMailRequestFromJSON(json: any): SendCheckoutFullfillmentShippingMailRequest {
    return SendCheckoutFullfillmentShippingMailRequestFromJSONTyped(json, false);
}

export function SendCheckoutFullfillmentShippingMailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendCheckoutFullfillmentShippingMailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullfillmentShippingMail': SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMailFromJSON(json['fullfillment_shipping_mail']),
    };
}

export function SendCheckoutFullfillmentShippingMailRequestToJSON(value?: SendCheckoutFullfillmentShippingMailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fullfillment_shipping_mail': SendCheckoutFullfillmentShippingMailRequestFullfillmentShippingMailToJSON(value.fullfillmentShippingMail),
    };
}

